module.exports = __webpack_public_path__ + "static/img/antiFraud_banner.80d540f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/homepageComponent/antiFraud/antiFraud_banner.jpg
// module id = 5gzz
// module chunks = 6